import Dexie, { Table } from 'dexie';
import {
  IMockAllCapabilitiesForUserTable,
  IMockFeatureToggleTable,
  IMockOrganizationTable,
  IMockProgressiveDeliveryAuditLogTable,
  IMockProgressiveDeliveryBlackoutTable,
  IMockProgressiveDeliveryConfigTable,
  IMockSelfTable,
  IMockUsersTable,
} from './types/mockDbTables';

export class MockDb extends Dexie {
  featureToggles!: Table<IMockFeatureToggleTable>;

  users!: Table<IMockUsersTable>;

  organizations!: Table<IMockOrganizationTable>;

  self!: Table<IMockSelfTable>;

  allCapabilitiesForUser!: Table<IMockAllCapabilitiesForUserTable>;

  pdConfigs!: Table<IMockProgressiveDeliveryConfigTable>;

  pdAuditLog!: Table<IMockProgressiveDeliveryAuditLogTable>;

  pdBlackoutDays!: Table<IMockProgressiveDeliveryBlackoutTable>;

  constructor() {
    super('mock-db');
    this.version(1).stores({
      featureToggles:
        '&name, description, clientId, category, isEnabled, selectedOrgs, selectedUsers',
      users: '&userId, fullName',
      organizations: '&orgId, name',
      self: '&id, firstName, lastName, email, phone, pid',
      allCapabilitiesForUser: '[userId+capabilityName], capabilityId',
    });
    this.version(3).stores({
      pdConfigs: '&toggleName, status',
      pdAuditLog: '++id, toggleName, performedAt',
    });
    this.version(4).stores({
      pdBlackoutDays: '&date',
    });
    // Holiday logic removed — PD non-working days are now manual blackout
    // dates only. version(5) created the observed-holiday store; version(6)
    // drops it so mock DBs that already ran version(5) migrate cleanly. Keep
    // BOTH entries as-is: collapsing this history would strand the store on
    // any browser that already upgraded to version(5).
    this.version(5).stores({
      pdObservedHolidays: '&date',
    });
    this.version(6).stores({
      pdObservedHolidays: null,
    });
  }
}

const db = new MockDb();

export const mockDb = db;
